const Error = ({ message, onRetry }) => {
    return (
        <div role="alert" className="mt-5 text-center">
            <h3 className="md:text-2xl text-xl text-red-500">
                {message || "Something went wrong while loading this section."}
            </h3>
            {onRetry && (
                <button
                    type="button"
                    onClick={onRetry}
                    className="focus:outline-none focus:ring-2 focus:ring-red-400 mt-3 text-sm underline"
                >
                    Try again
                </button>
            )}
        </div>
    );
};
export default Error;
